import { combineReducers } from '@reduxjs/toolkit';
import { dynamicReducer } from './slices/dynamic/index';
import schemaReducer from './slices/schema/reducer';
import additionalReportReducer from './slices/additional-report/reducer';
import deviceReducer from './slices/device/reducer';
import exportRequestReducer from './slices/export-request/reducer';
import deviceBrandReducer from './slices/device-brand/reducer';
import kitReducer from './slices/kit/reducer';
import kitDeviceReducer from './slices/kit-device/reducer';
import levelReducer from './slices/level/reducer';
import organizationReducer from './slices/organization/reducer';
import readingReducer from './slices/reading/reducer';
import reportReducer from './slices/report/reducer';
import reminderReducer from './slices/reminder/reducer';
import slaContentReducer from './slices/sla-content/reducer';
import subjectReducer from './slices/subject/reducer';
import subjectDoctorLogReducer from './slices/subject-doctor-log/reducer';
import subjectNoteReducer from './slices/subject-note/reducer';
import subjectOnBoardRemarkReducer from './slices/subject-on-board-remark/reducer';
import subscriptionPlanReducer from './slices/subscription-plan/reducer';
import systemApiModuleReducer from './slices/system-api-module/reducer';
import systemFileReducer from './slices/system-file/reducer';
import systemRoleReducer from './slices/system-role/reducer';
import systemUiModuleReducer from './slices/system-ui-module/reducer';
import systemUiModuleComponentReducer from './slices/system-ui-module-component/reducer';
import systemUserReducer from './slices/system-user/reducer';
import userReducer from './slices/user/reducer';

const reducer = combineReducers({
  dynamic: dynamicReducer,
  schema: schemaReducer,
  additionalReport: additionalReportReducer,
  device: deviceReducer,
  deviceBrand: deviceBrandReducer,
  exportRequest: exportRequestReducer,
  kit: kitReducer,
  kitDevice: kitDeviceReducer,
  level: levelReducer,
  organization: organizationReducer,
  reading: readingReducer,
  report: reportReducer,
  reminder: reminderReducer,
  slaContent: slaContentReducer,
  subject: subjectReducer,
  subjectDoctorLog: subjectDoctorLogReducer,
  subjectNote: subjectNoteReducer,
  subjectOnBoardRemark: subjectOnBoardRemarkReducer,
  subscriptionPlan: subscriptionPlanReducer,
  systemApiModule: systemApiModuleReducer,
  systemFile: systemFileReducer,
  systemRole: systemRoleReducer,
  systemUiModule: systemUiModuleReducer,
  systemUiModuleComponent: systemUiModuleComponentReducer,
  systemUser: systemUserReducer,
  user: userReducer
});

export default reducer;